<div class="concert-main container" *ngIf="concertService.concerts$.value">
  <nav
    aria-label="breadcrumb"
    class="breadcrumbMain container"
    (click)="breadBack()"
    *ngIf="concertGroupedSeoUrl"
  >
    <div class="breadcrumbBack">
      <i class="fa-solid fa-angle-left"></i>
      {{ "Back" | translate | async }}
    </div>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a
          [routerLink]="['/grouped-concert']"
          style="color: var(--primaryColor)"
        >
          {{ "Grouped Concert List" | translate | async }}
        </a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ concertGroupedSeoUrl }}
      </li>
    </ol>
  </nav>
  <div
    class="concert-list row"
    *ngIf="concertService.concerts$.value?.length > 0"
  >
    <div
      class="concert-item col-md-4 col-sm-12 col-12"
      *ngFor="let concert of concertService.concerts$.value"
    >
      <concert-item [concert]="concert"></concert-item>
    </div>
  </div>
  <div *ngIf="concertService.concerts$.value?.length == 0">
    <div class="container" style="padding: 10%">
      <div class="row dialog-glass-card" style="width: 90%; margin: auto">
        <div class="col-md-6" style="display: flex; justify-content: center">
          <img src="../../../../../assets/images/ticket.png" alt="ticket" />
        </div>
        <div
          class="col-md-6"
          style="display: flex; flex-direction: column; margin: auto"
        >
          <div style="font-size: 1.5rem; color: #f7c179; padding-bottom: 25px">
            Heyecan Verici Etkinlikler Yolda!
          </div>
          <div style="font-size: 1rem; padding-bottom: 25px">
            Su an icin aktif bir biletimiz bulunmuvor, ancak endiselenmevin!
            Sizler icin dopdolu bir etkinlik takvimi üzerinde calisiyoruz ve
            yakinda harika firsatlarla geri dönecediz!
          </div>
          <div style="font-size: 1rem; padding-bottom: 25px">
            Yeni biletlerimiz tekrar satista oldugunda haber vermek için
            <b>bizi takip etmeyi unutmayin.</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="concert-main container" *ngIf="!concertService.concerts$.value">
  <div class="concert-list row">
    <div class="concert-item col-md-3 is-loading">
      <div>&nbsp;</div>
    </div>
    <div class="concert-item col-md-3 is-loading">
      <div>&nbsp;</div>
    </div>
    <div class="concert-item col-md-3 is-loading">
      <div>&nbsp;</div>
    </div>
    <div class="concert-item col-md-3 is-loading">
      <div>&nbsp;</div>
    </div>
  </div>
</div>
